import React from "react";
import T from "prop-types";
import { usePageTitle } from "2g-hooks";
import { PageMessageError, PageMessageEmpty } from "2g-page-message";
import Loadbar from "2g-loadbar";

import { useProdukt } from "b2b/api/hooks";
import { useServerMessage } from "b2b/i18n";
import ProduktEditaceWidget from "b2b/components/produkt-editace-widget/ProduktEditaceWidget";

import useMessages from "./i18n/useMessages";

export function ProduktDetail({ id }) {
  const message = useServerMessage();
  const { titlePlaceholder, messageEmpty } = useMessages();
  const { data, loading, loaded, error } = useProdukt({ id });

  usePageTitle(data ? message(data, "nazev") : titlePlaceholder());

  return (
    <>
      {loading && <Loadbar />}
      {error ? (
        <PageMessageError error={error} />
      ) : !data && loaded ? (
        <PageMessageEmpty message={messageEmpty()} />
      ) : (
        <ProduktEditaceWidget produkt={data} loading={loading} />
      )}
    </>
  );
}

ProduktDetail.propTypes = { id: T.number.isRequired };

export default React.memo(ProduktDetail);
